var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dl',{staticClass:"propery"},[_c('dt',{staticClass:"propery__title"},[_c('span',[_vm._t("title")],2)]),_c('dd',{staticClass:"propery__value"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }